import { Controller } from 'react-hook-form';
import { Keyboard, StyleSheet, View } from 'react-native';
import { CheckboxOption as CropCircleCheckboxOption } from '../crop-circle/Components/CheckboxOption';
import { spacing } from '../crop-circle/tokens';

type RadioButtonOption = {
  label?: string;
  value: any;
};

type ControlledRadioButtonProps = {
  control: any;
  name: string;
  options: RadioButtonOption[];
  horizontal?: boolean;
  color?: string;
};

export const ControlledRadioButtons = ({
  control,
  name,
  options,
}: ControlledRadioButtonProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <View style={stylesCropCircle.container}>
          {options.map((option) => (
            <CropCircleCheckboxOption
              key={option.value}
              mode="radio"
              state={option.value === value ? 'checked' : 'unchecked'}
              label={option.label || option.value}
              // Blur any focused text input: selecting an option ends typing, and a
              // still-focused input makes Android snap the scroll back to its cursor.
              onPress={() => {
                Keyboard.dismiss();
                onChange(option.value);
              }}
            />
          ))}
        </View>
      )}
    />
  );
};

const stylesCropCircle = StyleSheet.create({
  container: {
    gap: spacing.sm,
  },
});
